import React from 'react'
import withCapabilities from '../../hoc/withCapabilities'
import { Box } from '@mui/material'
import theme from '../../theme'
import { MenuItem } from '../../types/menuItem.types'
import Header from '../Header/Header'

const GlobalPageWrapper: React.FC<{
  menuItems: MenuItem[]
  children: React.ReactNode
}> = ({ menuItems, children }) => {
  const avatarMenuItems = menuItems.filter((item) => item.section === 'avatar')
  const mainMenuItems = menuItems.filter((item) => item.section !== 'avatar')
  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.default,
        height: '100vh',
        '@supports (height: 100dvh)': {
          height: '100dvh',
        },
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <Header mainMenuItems={mainMenuItems} avatarMenuItems={avatarMenuItems} />
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          display: 'flex',
          flexDirection: 'column',
          overflowY: 'auto',
          // Hide scrollbar — only used as fallback for pages without PageTemplate
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
          '&::-webkit-scrollbar': { display: 'none' },
        }}
      >
        {children}
      </Box>
    </Box>
  )
}

export default withCapabilities(GlobalPageWrapper)
